
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_fvjdu_ft463_93",
  "button": "awsui_button_fvjdu_ft463_136",
  "dots": "awsui_dots_fvjdu_ft463_137",
  "button-disabled": "awsui_button-disabled_fvjdu_ft463_165",
  "arrow": "awsui_arrow_fvjdu_ft463_170",
  "page-number": "awsui_page-number_fvjdu_ft463_180",
  "button-current": "awsui_button-current_fvjdu_ft463_186",
  "page-item": "awsui_page-item_fvjdu_ft463_203",
  "root-disabled": "awsui_root-disabled_fvjdu_ft463_221"
};
  